import React, { useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import CountUp from "react-countup";
import SbEditable from "storyblok-react";
import RichText from "src/utils/RichText";

const Stat = ({ blok }) => {
  const [active, setActive] = useState(true);

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="md:w-1/3 w-full text-center flex flex-col items-center justify-center py-6">
        <CountUp
          start={active && 0}
          end={parseFloat(blok.number).toFixed(1)}
          duration={3}
          prefix={blok.char_before}
          suffix={blok.char_after}
          decimals={blok.is_decimal ? 1 : 0}
          decimal="."
        >
          {({ countUpRef }) => (
            <VisibilitySensor
              onChange={(isVisible) => isVisible && setActive(false)}
              delayedCall
            >
              <dt
                className="text-8xl lg:text-[7.5rem] font-display text-red border-t border-sepgrey px-5 pt-8"
                ref={countUpRef}
              />
            </VisibilitySensor>
          )}
        </CountUp>
        <dd className="font-body max-w-xs prose leading-6 text-white text-sm">
          <RichText>{blok.description}</RichText>
        </dd>
      </div>
    </SbEditable>
  );
};

export default Stat;
